<script>
  import hotspotLogo from "../assets/img/hotspot.png";
  import back from "../assets/img/back.png";
  import Error from "./components/Error.svelte";

  import { onMount } from "svelte";
  import { loadingStop } from "./utils.svelte";

  const baseURL = import.meta.env.VITE_BASE_URL;

  export let store;

  let phoneNumber = store.cellphone;
  let pinInput = null;
  let isResetButtonDisabled = false;
  let resetButtonTimer = null;
  let errorMessage = null;

  function clearInput() {
    document.getElementById("pin1").value = "";
    document.getElementById("pin2").value = "";
    document.getElementById("pin3").value = "";
    document.getElementById("pin4").value = "";

    document.getElementById("pin1").focus();
  }

  async function resetPin() {
    if (isResetButtonDisabled) return;

    isResetButtonDisabled = true;
    resetButtonTimer = setTimeout(() => {
      isResetButtonDisabled = false;
    }, 60000);

    clearInput();

    const response = await fetch(`${baseURL}pin/new/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        phone_number: phoneNumber,
      }),
    });

    if (response.ok) {
      // Pass
    } else {
      errorMessage = "Failed to reset PIN";
      clearInput();
    }
  }

  async function handleSubmit(event) {
    event.preventDefault();

    const pin1 = document.getElementById("pin1").value;
    const pin2 = document.getElementById("pin2").value;
    const pin3 = document.getElementById("pin3").value;
    const pin4 = document.getElementById("pin4").value;

    const pinInput = parseInt(pin1 + pin2 + pin3 + pin4);
    console.log("PIN Input", pinInput);

    const response = await fetch(`${baseURL}pin/login/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        phone_number: phoneNumber,
        pin: pinInput,
        // TODO: remove this default MAC before deploy
        mac: store.macAddress ?? "00:00:00:00:00:00",
      }),
    });

    if (response.ok) {
      store.setState("ACCOUNT");
    } else {
      errorMessage = "PIN invalid";
      clearInput();
    }
  }

  $: resetButtonText = isResetButtonDisabled
    ? "New PIN in 60 seconds"
    : "Reset here";
</script>

<div class="flex flex-col justify-center mt-32 px-4">
  <div class="w-full">
    <button class="flex flex-row" on:click={store.setState("LANDING")}>
      <img class="w-3" src={back} alt="Back button" />
      <div class="w-1"></div>
      <p class="text-[#5b95c8] text-xl font-bold">Back</p>
    </button>
  </div>

  <img
    src={hotspotLogo}
    alt="TooMuchWifi Hotspot logo"
    class="w-56 mb-6 mx-auto"
  />

  <div class="h-24"></div>

  {#if errorMessage}
    <Error message={errorMessage}></Error>
  {/if}

  <p class="text-md mb-2">Enter your PIN</p>

  <form on:submit={handleSubmit} class="w-full max-w-md mx-auto">
    <div class="flex flex-row justify-between">
      <input
        type="tel"
        id="pin1"
        required
        maxlength="1"
        minlength="1"
        class="block text-xl px-3 py-4 mb-4 border border-gray-300 rounded focus:outline-none text-center focus:ring-2 focus:ring-blue-500 w-16"
        on:input={(e) => {
          if (e.target.value.length === 1) {
            document.getElementById("pin2").focus();
          }
        }}
      />
      <input
        type="tel"
        id="pin2"
        required
        maxlength="1"
        minlength="1"
        class="block text-xl px-3 py-4 mb-4 border border-gray-300 rounded focus:outline-none text-center focus:ring-2 focus:ring-blue-500 w-16"
        on:input={(e) => {
          if (e.target.value.length === 1) {
            document.getElementById("pin3").focus();
          } else if (e.target.value.length === 0) {
            document.getElementById("pin1").focus();
          }
        }}
      />
      <input
        type="tel"
        id="pin3"
        required
        maxlength="1"
        minlength="1"
        class="block text-xl px-3 py-4 mb-4 border border-gray-300 rounded focus:outline-none text-center focus:ring-2 focus:ring-blue-500 w-16"
        on:input={(e) => {
          if (e.target.value.length === 1) {
            document.getElementById("pin4").focus();
          } else if (e.target.value.length === 0) {
            document.getElementById("pin2").focus();
          }
        }}
      />
      <input
        type="tel"
        id="pin4"
        required
        maxlength="1"
        minlength="1"
        class="block text-xl px-3 py-4 mb-4 border border-gray-300 rounded focus:outline-none text-center focus:ring-2 focus:ring-blue-500 w-16"
        on:input={(e) => {
          if (e.target.value.length === 0) {
            document.getElementById("pin3").focus();
          }
        }}
      />
    </div>

    <div class="flex flex-row items-center justify-center mt-2 px-4">
      <p class="text-sm mb-2">Forgot your PIN?</p>
      <button
        class={`hover:cursor-pointer text-blue-600 text-sm mb-2 ml-2 underline ${isResetButtonDisabled ? "opacity-50 cursor-not-allowed" : ""}`}
        on:click={resetPin}
      >
        {resetButtonText}
      </button>
    </div>

    <p class="text-center text-sm my-1">
      Please note this PIN will be your default
    </p>

    <div class="h-7"></div>

    <button
      type="submit"
      class="bg-[#009946] py-5 text-white font-bold rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 w-80"
    >
      Submit
    </button>
  </form>
</div>
